import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ClipboardList, LogOut } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const isActive = (path) => location.pathname === path;

  const handleLogout = () => {
    if (window.confirm('Do you surely want to log out?')) logout();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-[0_-2px_8px_rgba(0,0,0,0.06)]" data-testid="bottom-nav">
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto">
        <button onClick={() => navigate('/')} className={`flex flex-col items-center gap-0.5 px-4 py-1.5 rounded-lg transition-colors ${isActive('/') ? 'text-[#1A3626]' : 'text-gray-400'}`} data-testid="bottom-home">
          <Home className="h-5 w-5" />
          <span className="text-[10px] font-semibold">Home</span>
        </button>
        <button onClick={() => navigate('/my-orders')} className={`flex flex-col items-center gap-0.5 px-4 py-1.5 rounded-lg transition-colors ${isActive('/my-orders') ? 'text-[#1A3626]' : 'text-gray-400'}`} data-testid="bottom-orders">
          <ClipboardList className="h-5 w-5" />
          <span className="text-[10px] font-semibold">Your Orders</span>
        </button>
        <button onClick={handleLogout} className="flex flex-col items-center gap-0.5 px-4 py-1.5 rounded-lg text-red-400 hover:text-red-500 transition-colors" data-testid="bottom-logout">
          <LogOut className="h-5 w-5" />
          <span className="text-[10px] font-semibold">Logout</span>
        </button>
      </div>
    </div>
  );
};

export default BottomNav;
